/* Zorina Mast — slideri i tabovi za početnu/kolekcije */
(function () {
  'use strict';
  function initSlider(root) {
    if (root.dataset.zpInit) return;
    root.dataset.zpInit = '1';
    var track = root.querySelector('.zp-sl__track');
    if (!track) return;
    var prev = root.querySelector('.zp-sl__nav--prev');
    var next = root.querySelector('.zp-sl__nav--next');
    var dots = root.querySelector('.zp-sl__dots');
    var loop = root.hasAttribute('data-loop');
    function step() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function pages() { return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth)); }
    function idx() { return Math.round(track.scrollLeft / step()); }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = !loop && track.scrollLeft <= 2;
      if (next) next.disabled = !loop && track.scrollLeft >= max - 2;
      if (max <= 2) { if (prev) prev.disabled = true; if (next) next.disabled = true; }
      if (dots) {
        var per = Math.max(1, Math.round(track.clientWidth / step()));
        var cur = Math.round(idx() / per);
        if (track.scrollLeft >= max - 2) cur = dots.children.length - 1;
        Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      }
    }
    function buildDots() {
      if (!dots) return;
      dots.innerHTML = '';
      var n = pages();
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Slajd ' + (i + 1));
        b.dataset.i = i;
        dots.appendChild(b);
      }
    }
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth;
      var to = track.scrollLeft + dir * step();
      if (loop) { if (to > max + 2) to = 0; else if (to < -2) to = max; }
      track.scrollTo({ left: to, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if (dots) dots.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      track.scrollTo({ left: Math.min(b.dataset.i * track.clientWidth, track.scrollWidth - track.clientWidth), behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { buildDots(); update(); });
    buildDots(); update();
    var auto = parseFloat(root.dataset.autoplay || '0');
    if (auto > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var t = setInterval(function () { if (!document.hidden) go(1); }, auto * 1000);
      root.addEventListener('pointerenter', function () { clearInterval(t); }, { once: true });
    }
  }
  function initTabs(root) {
    if (root.dataset.zpInit) return;
    root.dataset.zpInit = '1';
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zp-tab]'); if (!b) return;
      root.querySelectorAll('[data-zp-tab]').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      root.querySelectorAll('[data-zp-panel]').forEach(function (p) { p.hidden = p.dataset.zpPanel !== b.dataset.zpTab; });
    });
  }
  function scan() {
    document.querySelectorAll('[data-zp-sl]').forEach(initSlider);
    document.querySelectorAll('[data-zp-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
